import { useEffect } from 'react'
import { useState } from 'react'
import api from '../../services/api.js'
import '../autocomplete-cliente/autocomplete-cliente.css'
import btnClear from '../../assets/clear.png'
import btnSearch from '../../assets/clear.png'
import { BiSearch } from 'react-icons/bi'

function AutocompleteClienteDefault(props) {
  const [texto, setTexto] = useState('')
  const [lista_clientes, setListaClientes] = useState([])
  const [botaoAtivo, setBotaoAtivo] = useState(true)
  const [valorAnterior, setValorAnterior] = useState('')

  function PesquisarClientes(busca) {
    console.log('busca' + busca)

    if (busca.length > 2) {
      api
        .get('/clientes', {
          params: {
            razao: busca,
            conta: localStorage.idconta,
          },
        })
        .then((retorno) => {
          setListaClientes(retorno.data)
          console.log(retorno.data)
        })
        .catch((err) => {
          console.log(err)
          alert('Erro ao consultar clientes')
        })
    } else {
      setListaClientes([])
    }
  }

  function Filtrar() {
    if (botaoAtivo) {
      if (valorAnterior !== texto) {
        setBotaoAtivo(false)
        PesquisarClientes(texto)
        setValorAnterior(texto)
        setTimeout(() => {
          setBotaoAtivo(true)
        }, 1000) // Tempo em milissegundos para reativar o botão
      }
    }
  }

  function SelecionarItem(id, nome, cpf) {
    setTexto(nome)

    props.onClickId(id)
    props.onClickNome(nome)
    props.onClickCpf(cpf)

    setListaClientes([])
  }

  function Clear() {
    setTexto('')
    props.onClickId(0)
    props.onClickNome('')
    props.onClickCpf('')
    setListaClientes([])
  }

  useEffect(() => {
    document.addEventListener('click', (e) => setListaClientes([]))
  }, [])

  useEffect(() => {
    setTexto(props.value)
  }, [props.value])

  return (
    <div className="autocomplete">
      <div className="autocomplete d-flex align-items-center">
        <input
          type="text"
          className="form-control flex-grow-1 mr-2"
          placeholder={props.placeholder}
          value={texto}
          onChange={(event) => setTexto(event.target.value)}
        />
        <button
          className="btn btn-primary"
          onClick={Filtrar}
          disabled={!botaoAtivo}
        >
          <BiSearch className="autocomplete-icon" />
        </button>
      </div>

      {texto.length > 0 ? (
        <button
          className="autocomplete-clear"
          onClick={Clear}
        >
          <img
            src={btnClear}
            className="autocomplete-img"
          />
        </button>
      ) : null}

      {Array.isArray(lista_clientes) ? (
        <div className="autocomplete-items">
          {lista_clientes.map((cli) => {
            return (
              <div
                key={cli.PES_CNPJ_CPF}
                className="autocomplete-item"
                onClick={(e) =>
                  SelecionarItem(
                    cli.COD_PESSOA,
                    cli.PES_RAZAO,
                    cli.PES_CNPJ_CPF,
                  )
                }
              >
                <b>{cli.PES_RAZAO}</b>
                <br />
                <small className="text-secondary">
                  Código: {cli.COD_PESSOA}
                </small>
                <br />
                <small className="text-secondary">
                  CNPJ/CPF: {cli.PES_CNPJ_CPF}
                </small>
                <br />
              </div>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default AutocompleteClienteDefault
